import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import { MuiTelInput } from 'mui-tel-input';
import { Controller } from 'react-hook-form';

import Button from '@/components/Button';
import InputField from '@/components/InputField';

import type { IEditProfile } from '../interfaces';

const PersonalData = ({
  register,
  errors,
  control,
  submitForm,
  handleChangeSelectedCountryPhone,
}: IEditProfile) => {
  const theme = useTheme();

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      sx={{
        justifyContent: 'flex-end',
      }}
    >
      <Grid size={{ xxs: 12, md: 6 }}>
        <InputField
          label="Nombre(s)"
          name="profile.firstName"
          errors={errors}
          register={register}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
          icon={<PersonOutlineOutlinedIcon />}
        />
      </Grid>
      <Grid size={{ xxs: 12, md: 6 }}>
        <InputField
          label="Apellido(s)"
          name="profile.lastName"
          errors={errors}
          register={register}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
          icon={<PersonOutlineOutlinedIcon />}
        />
      </Grid>
      <Grid size={{ xxs: 12 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', margin: '1rem 0.5rem 0.5rem 0' }}>
          <Icon color="disabled" sx={{ marginRight: '0.5rem' }}>
            <PhoneIphoneOutlinedIcon />
          </Icon>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',

              color: theme.palette.secondary.main,
              fontSize: '1rem',
            }}
          >
            Teléfono
          </Typography>
        </Box>
        <Controller
          name="profile.phone"
          control={control}
          render={({ field }) => (
            <MuiTelInput
              sx={{ width: '100%' }}
              onlyCountries={['MX', 'PE', 'CO', 'CL']}
              defaultCountry="MX"
              error={!!errors.profile?.phone}
              helperText={errors.profile?.phone?.message}
              {...field}
              onChange={(e, country) => {
                field.onChange(e.replace(/\s/g, ''));
                handleChangeSelectedCountryPhone?.(country.countryCode!);
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xxs: 12 }}>
        <InputField
          label="Email"
          name="profile.email"
          errors={errors}
          disabled
          register={register}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
          icon={<EmailOutlinedIcon />}
        />
      </Grid>
      <Grid>
        <Button
          onClick={() => submitForm?.('profile')}
          disabled={Object.entries(errors.profile! ?? {}).length > 0}
        >
          Actualizar datos
        </Button>
      </Grid>
    </Grid>
  );
};

export default PersonalData;
